var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01 align center"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.3333 13.945H0.666626V2.13949C0.666626 1.58695 0.886119 1.05705 1.27682 0.666347C1.66752 0.275646 2.19743 0.0561523 2.74996 0.0561523H15.25C15.8025 0.0561523 16.3324 0.275646 16.7231 0.666347C17.1138 1.05705 17.3333 1.58695 17.3333 2.13949V13.945ZM2.05551 12.5562H15.9444V2.13949C15.9444 1.95531 15.8712 1.77867 15.741 1.64844C15.6108 1.51821 15.4341 1.44504 15.25 1.44504H2.74996C2.56578 1.44504 2.38915 1.51821 2.25891 1.64844C2.12868 1.77867 2.05551 1.95531 2.05551 2.13949V12.5562Z",
    fill: "#57689F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.5555 6.30615H6.91663V7.69505H14.5555V6.30615Z",
    fill: "#57689F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.52767 6.30615H3.44434V7.69505H5.52767V6.30615Z",
    fill: "#57689F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.0832 9.77881H3.44434V11.1677H11.0832V9.77881Z",
    fill: "#57689F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M14.5556 9.77881H12.4723V11.1677H14.5556V9.77881Z",
    fill: "#57689F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderList);
export default __webpack_public_path__ + "static/media/order_list.7090a07fe1d7eba0da3d52cf988f7aa6.svg";
export { ForwardRef as ReactComponent };